import urlapi from 'url';
import axiosInstance from '../../axios-config';

const facilityInfoApi = '/api/facilities?facilityAlias={0}';
const facilityPatientInfoApi = '/api/patients/{0}/facilities';
const facilityLogoApi = '/api/facilities/{0}/images/logoUrl';
const facilityThemeApi = '/api/themes/{0}/css';
const facilityFaqsApi = 'api/facilities/{0}/faqs ';
const getUsefulLinksApi = 'api/facilityContent/{facilityId}/usefulLinks/value';
const getDownloadableFormsApi = 'api/facilities/{facilityId}/downloadableContent';
const getDownloalApi = '/api/facilities/{facilityId}/downloadableContent/{formId}?token={token}';
const getPrivacyStatementApi = '/api/facilityContent/{facilityId}/privacyStatement/value';
const getSignupLegalStatementApi = '/api/facilityContent/{facilityId}/signupLegalStatement/value';

export const getDownloadLink = (facilityId, formId, accessToken) => (
  axiosInstance.defaults.baseURL +
  getDownloalApi
    .replace('{facilityId}', facilityId)
    .replace('{formId}', formId)
    .replace('{token}', accessToken)
);

export const getFacilityInfo = (urlpath) => {
  let facilityAlias;
  const serverConfig = urlapi.parse(urlpath);
  if (serverConfig.port === null) {
    facilityAlias = serverConfig.hostname;
  } else {
    facilityAlias = serverConfig.hostname + ':' + serverConfig.port;
  }
  if (urlpath) {
    return axiosInstance.get(
      facilityInfoApi.replace('{0}', facilityAlias)
    );
  }
  return null;
};

export const getPatientFacilityInfo = (patientId) => (
  axiosInstance.get(facilityPatientInfoApi.replace('{0}', patientId))
);

export const getLogoUrl = (facilityId) => (
  axiosInstance.defaults.baseURL.concat(facilityLogoApi.replace('{0}', facilityId))
);

export const getThemeSource = (themeId) => (
  axiosInstance.defaults.baseURL.concat(facilityThemeApi.replace('{0}', themeId))
);

export const getFaqs = (facilityId) => (
  axiosInstance.get(facilityFaqsApi.replace('{0}', facilityId))
);

export const getUsefulLinks = (facilityId) => (
  axiosInstance.get(getUsefulLinksApi.replace('{facilityId}', facilityId))
);

export const getDownloadableForms = (facilityId) => (
  axiosInstance.get(getDownloadableFormsApi.replace('{facilityId}', facilityId))
);

export const getPrivacyStatement = (facilityId) => (
  axiosInstance.get(getPrivacyStatementApi.replace('{facilityId}', facilityId))
);

export const getSignupLegalStatement = (facilityId) => (
  axiosInstance.get(getSignupLegalStatementApi.replace('{facilityId}', facilityId))
);
